/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Panel_TitleInputs */

const en_chat_panel_title = /** @type {(inputs: Chat_Panel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assistant`)
};

const fr_chat_panel_title = /** @type {(inputs: Chat_Panel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assistant`)
};

const ms_sg2_chat_panel_title = /** @type {(inputs: Chat_Panel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembantu`)
};

/**
* | output |
* | --- |
* | "Assistant" |
*
* @param {Chat_Panel_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const chat_panel_title = /** @type {((inputs?: Chat_Panel_TitleInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Panel_TitleInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_panel_title(inputs)
	if (locale === "fr") return fr_chat_panel_title(inputs)
	return ms_sg2_chat_panel_title(inputs)
});